module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group places-input-group"
  }, [_vm._t("before"), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "autocomplete": "off",
      "id": _vm.attrs.id,
      "placeholder": _vm.attrs.placeholder,
      "disabled": _vm.attrs.disabled
    },
    domProps: {
      "value": _vm.inputValue
    },
    on: {
      "input": _vm.input,
      "focus": _vm.focus,
      "keydown": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
        return _vm.up($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        return _vm.down($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.enter($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.triggerBlur($event)
      }],
      "blur": _vm.blur
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu-container"
  }, [_c('ul', {
    staticClass: "dropdown-menu",
    class: {
      'show': _vm.showDropdown
    }
  }, _vm._l((_vm.places), function(p, index) {
    return _c('li', {
      class: {
        'selected': index === _vm.selectedPlace
      },
      on: {
        "mousemove": function($event) {
          return _vm.setSelected(index)
        },
        "mousedown": function($event) {
          $event.preventDefault();
          return _vm.fetchPlace(p)
        }
      }
    }, [_vm._v(_vm._s(p.description) + "\n      ")])
  }), 0)]), _vm._v(" "), _vm._t("after")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-96ba037e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/markerEdit/InputPlaces.vue
// module id = 1065
// module chunks = 1